import { ReactElement } from 'react';
import { useViewProvider } from '../../modules/contexts/view-provider-context/ViewProvider';
import { LoginByVinErrorPageViewProps } from "./LoginByVinErrorPageViewProps";
import { PageRoutes } from "../../modules/navigation/PageRoutes";
import { useBrandNavigate } from "../../modules/navigation/UseBrandNavigate";

export function LoginByVinErrorPage(): ReactElement {
  const navigate = useBrandNavigate();
  const viewProvider = useViewProvider();

  const onClick = (): void => {
    navigate(PageRoutes.LoginByVin);
  };

  const viewProps: LoginByVinErrorPageViewProps = {
    onClick,
  };
  return viewProvider.renderLoginByVinErrorPage(viewProps);
}
